import { _axios } from '@/plugins/axios'
import i18n from '@/plugins/i18n'

const state = {
  questionnaires: [],
  userCount: 0,
}

const getters = {
  userCount: state => state.userCount,
  questionnaires: state => state.questionnaires,
}

const actions = {
  loadDashboardStats: ({ commit, dispatch }) => {
    return _axios.get('dashboard-stats/')
                 .then(response => {
                   commit('USER_COUNT_UPDATE', response.data.accounts)

                   const convertIterations = ({
                     finished_per_date: chartData,
                     ...remain // total, open, finished
                   }) => ({
                     ...remain,
                     chartData: chartData.map(dateObject => {
                       const [date, value] = Object.entries(dateObject)[0]
                       return { date, value }
                     }),
                   })
                   const convertQuestionnaire = ({
                     publication_date: publicationDate,
                     is_published: isPublished,
                     iterations,
                     ...remain // id, label, user
                   }) => (
                     {
                       ...remain,
                       publicationDate: publicationDate
                                        ? new Date(publicationDate).toLocaleDateString()
                                        : null,
                       isPublished,
                       iterations: convertIterations(iterations),
                     })
                   commit('QUESTIONNAIRES_LOAD', response.data.questionnaires.map(convertQuestionnaire))
                 })
                 .catch(error => {
                   dispatch('displayError', { action: i18n.t('store.user.unknown'), error }, { root: true })
                 })
  },
}

const mutations = {
  USER_COUNT_UPDATE: (state, count) => {
    state.userCount = count
  },
  QUESTIONNAIRES_LOAD: (state, questionnaires) => {
    state.questionnaires = questionnaires
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
